import { isEmpty } from 'underscore';
import { useContext, useState, useEffect } from 'react';
import { ConversionDataContext } from './conversion-data-context';

export const isDataReady = data => !isEmpty(data) && data.id && data.type;

export const useInitConversionTagData = (tagContext) => {
  const { instrumentation } = useContext(ConversionDataContext);
  const [isDataInited, setIsDataInited] = useState(false);

  const {
    data,
    isLoading,
    error,
    getTag,
    isInitialized,
  } = tagContext;

  useEffect(() => {
    if (isInitialized && !isDataReady(data) && !isLoading && !error && !isDataInited) {
      instrumentation.logTrace('[useInitConversionTagData] Fetch tag context');
      setIsDataInited(true);
      getTag();
    }
  }, [data, isInitialized, isLoading, error, isDataInited, getTag, instrumentation]);
};

export const useInitConversionGoalData = (goalContext) => {
  const [isDataInited, setIsDataInited] = useState(false);

  const {
    isLoading,
    data,
    error,
    getGoals,
  } = goalContext;

  useEffect(() => {
    if (isEmpty(data) && !isLoading && isEmpty(error) && !isDataInited) {
      setIsDataInited(true);
      getGoals();
    }
  }, [getGoals, data, error, isDataInited, isLoading]);
};
